var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('title-bar',{attrs:{"title-stack":_vm.titleStack}}),_c('updatesToCustomers')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }